var _path, _path2, _path3, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49978 4.5C7.99836 2.75072 10.8748 4.875 11.9998 6.375C13.1248 4.875 16.0012 2.75073 19.4998 4.5C23.9998 6.74999 22.8748 12.375 19.4998 15.75C17.853 17.3968 14.9527 20.2971 12.8314 21.9103C12.3413 22.283 11.6709 22.2663 11.1918 21.8796C9.2473 20.31 6.12356 17.3738 4.49978 15.75C1.12477 12.375 -0.000217319 6.75 4.49978 4.5Z",
    fill: "#F8312F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.37499V8.66186C12.952 6.64876 15.3187 3.96038 19.2432 4.37809C15.861 2.85467 13.0971 4.91181 11.9998 6.37499Z",
    fill: "#CA0B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95905 4.15268C7.6959 3.71254 6.16862 3.66559 4.49978 4.5C-0.00021708 6.75 1.12477 12.375 4.49978 15.75C6.12356 17.3738 9.2473 20.31 11.1918 21.8796C11.6709 22.2663 12.3413 22.283 12.8314 21.9103C13.022 21.7653 13.219 21.6099 13.4207 21.446C11.2797 19.8393 8.27504 17.3071 6.64411 15.8494C2.92651 12.5265 1.68733 6.98841 6.64411 4.77319C7.44947 4.41327 8.2249 4.2199 8.95905 4.15268Z",
    fill: "#CA0B4A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6079,
    cy: 9.4453,
    rx: 2.12666,
    ry: 3.58594,
    transform: "rotate(30 17.6079 9.4453)",
    fill: "#F37366"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.296c4712.svg";
export { ForwardRef as ReactComponent };